import { render } from "./BTWallCellsMobile.vue?vue&type=template&id=0cf9a41f&scoped=true"
import script from "./BTWallCellsMobile.vue?vue&type=script&lang=js"
export * from "./BTWallCellsMobile.vue?vue&type=script&lang=js"

import "./BTWallCellsMobile.vue?vue&type=style&index=0&id=0cf9a41f&scoped=true&lang=css"
import "./BTWallCellsMobile.vue?vue&type=style&index=1&id=0cf9a41f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf9a41f"]])

export default __exports__